export default "__VITE_ASSET__DKqgDJuU__"